export default "__VITE_ASSET__DCfj5nb0__"